export const ADD_PRODUTO = "ADD_PRODUTO";
export const EDIT_PRODUTO = "EDIT_PRODUTO";
export const REMOVE_PRODUTO = "REMOVE_PRODUTO";
export const SET_PRODUTOR = "SET_PRODUTOR";
